import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, createVNode as _createVNode, Transition as _Transition, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icon/player.png'


const _withScopeId = n => (_pushScopeId("data-v-bc27f8a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "column-preview rel" }
const _hoisted_2 = { class: "preview-main rel" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"100%"},
  src: "https://static-s.theckb.com/BusinessMarket/Client/shop_img_back.png",
  alt: ""
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"100%"},
  src: "https://static-s.theckb.com/BusinessMarket/Client/shop_img_back.png",
  alt: ""
}, null, -1))
const _hoisted_5 = { class: "zoom abs lg-shadow of-hd" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"100%"},
  src: "https://static-s.theckb.com/BusinessMarket/Client/shop_img_back.png",
  alt: ""
}, null, -1))
const _hoisted_8 = {
  key: 1,
  class: "scale-post rel"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-center abs-wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "play-btn flex-center" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "no-event",
      src: _imports_0,
      alt: ""
    })
  ])
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "flex-ter-bwn" }
const _hoisted_12 = {
  key: 0,
  class: "country-content"
}
const _hoisted_13 = { class: "country-name" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "country-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://static-s.theckb.com/BusinessMarket/Client/country/korea_icon.png",
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("span", null, "Korea")
], -1))
const _hoisted_15 = {
  key: 1,
  class: "flex-ter"
}
const _hoisted_16 = {
  key: 0,
  class: "fa fa-star"
}
const _hoisted_17 = {
  key: 1,
  class: "fa fa-star-o"
}

import { t } from '@/plugins/i18n'
import { ref, computed, watch, onMounted } from 'vue'
import PreviewList from './PreviewList.vue'
import VideoUi from './Video.vue'
import { useStore } from 'vuex'
import { confirmLogin } from '@/util/useConfirm'
import { goodsProductAdd, goodsProductCancel } from '@/apis/usercenter'
import LogoIcon from '@/components/common/LogoIcon.vue'
import MemberEventBox from '@/components/common/MemberEventBox.vue'
import { useWaterMark } from '@/util/useMark'
import BlackMask from '@/components/BlackGoods/BlackMask.vue'
import { isJA } from '@/store'

export default /*#__PURE__*/_defineComponent({
  props: ['product', 'isMultiGoods'],
  setup(__props) {

const props = __props

const store = useStore()

const skuImg = ref('')
// 照片列表
const imgList = ref([] as any[])

onMounted(() => {
  // store.commit('goods/skuImg', '')
})

console.log(store.state.goods.skuImg, 'store.state.goods.skuImg');

watch(() => store.state.goods.skuImg, async () => {
  if ((props.product.productTag === 1 && !isJA()) || (isJA() && props.product.countryProductTag === 1)) {
    skuImg.value = (await useWaterMark(store.state.goods.skuImg)).url
  } else {
    skuImg.value = store.state.goods.skuImg
  }
})

const media = computed(() => {
  if (props.product.productCode) {
    const m = props.product.productItemImgs?.map((v: any) => v.url) || []
    if (props.product.productVideo) {
      m.unshift({
        src: props.product.productVideo,
        post: ''
      })
    }
    return m
  } else {
    return []
  }
})

watch(() => media.value, async () => {
  const list = media.value.filter((v: any) => v.post || v)
  imgList.value = list
  if ((props.product.productTag === 1 && !isJA()) || (isJA() && props.product.countryProductTag === 1)) {
    const markList = list.map(async (item: any) => {
      return isImg(item) ? (await useWaterMark(item)).url : item
    })
    Promise.all(markList).then(res => {
      imgList.value = res
    })
  }
})

const cur = ref(0)

// const isImg = (url: string) => /\.(jpg|png|jpeg|webp|gif|bmp)/.test(url)
const isImg = (url: string) => typeof url === 'string'

const showZoom = ref(false)

const translate = ref('')
const bgPosition = ref('')

const move = (e: MouseEvent): void => {
  let { offsetX: x, offsetY: y } = e
  x = Math.min(Math.max(100, x), 300)
  y = Math.min(Math.max(100, y), 300)
  translate.value = `translate(${x}px,${y}px)`
  bgPosition.value = `translate(-${2 * x}px,-${2 * y}px)`
}

const addFavo = (prod: any) => {
  confirmLogin(() => {
    const api = prod.isfavo ? goodsProductCancel : goodsProductAdd
    const { productCode } = prod
    api({ productCode }).then((res: any) => {
      if (res.success) prod.isfavo = !prod.isfavo
    })
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (skuImg.value)
        ? (_openBlock(), _createBlock(_component_el_image, {
            key: 0,
            "data-goods": "",
            src: skuImg.value,
            onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (showZoom.value = true)),
            onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (showZoom.value = false)),
            onMousemove: move,
            "preview-src-list": [skuImg.value],
            "hide-on-click-modal": true,
            fit: "contain"
          }, {
            error: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["src", "preview-src-list"]))
        : (isImg(imgList.value[cur.value]))
          ? (_openBlock(), _createBlock(_component_el_image, {
              key: 1,
              referrerPolicy: "no-referrer",
              "data-goods": "",
              src: imgList.value[cur.value],
              onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (showZoom.value = true)),
              onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (showZoom.value = false)),
              onMousemove: move,
              "preview-src-list": imgList.value,
              "initial-index": cur.value,
              "hide-on-click-modal": true,
              "preview-teleported": true,
              fit: "contain"
            }, {
              error: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["src", "preview-src-list", "initial-index"]))
          : (_openBlock(), _createBlock(VideoUi, _normalizeProps(_mergeProps({ key: 2 }, imgList.value[cur.value])), null, 16)),
      _withDirectives(_createElementVNode("div", {
        class: "mask abs no-event",
        style: _normalizeStyle({ transform: translate.value })
      }, null, 4), [
        [_vShow, showZoom.value]
      ]),
      _createVNode(BlackMask, {
        type: "detail",
        item: __props.product
      }, null, 8, ["item"])
    ]),
    _createVNode(_Transition, {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut"
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          _createElementVNode("img", {
            "data-goods": "",
            src: skuImg.value || imgList.value[cur.value],
            alt: "",
            style: _normalizeStyle({ transform: bgPosition.value })
          }, null, 12, _hoisted_6)
        ], 512), [
          [_vShow, showZoom.value]
        ])
      ]),
      _: 1
    }),
    _createVNode(PreviewList, {
      index: cur.value,
      "onUpdate:index": _cache[4] || (_cache[4] = ($event: any) => ((cur).value = $event)),
      list: imgList.value
    }, {
      default: _withCtx(({ item }) => [
        (isImg(item))
          ? (_openBlock(), _createBlock(_component_el_image, {
              key: 0,
              referrerPolicy: "no-referrer",
              class: "scale-img",
              src: item,
              alt: ""
            }, {
              error: _withCtx(() => [
                _hoisted_7
              ]),
              _: 2
            }, 1032, ["src"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
      ]),
      _: 1
    }, 8, ["index", "list"]),
    _createElementVNode("div", _hoisted_11, [
      (__props.isMultiGoods)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(t)('品牌国家')), 1),
            _hoisted_14
          ]))
        : (_openBlock(), _createElementBlock("label", _hoisted_15, [
            _createTextVNode(_toDisplayString(_unref(t)('商品来源')) + " ", 1),
            _createVNode(LogoIcon, {
              class: "ml_5",
              type: __props.product.platformType,
              url: __props.product.productDetailUrl,
              underline: __props.product.channel === 5
            }, null, 8, ["type", "url", "underline"])
          ])),
      _createVNode(MemberEventBox, {
        subscript: false,
        "listen-variable": __props.product.isfavo
      }, {
        default: _withCtx(() => [
          _createElementVNode("label", {
            class: "flex-ter favo btn",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (addFavo(__props.product)))
          }, [
            _createTextVNode(_toDisplayString(_unref(t)('加入收藏夹')) + " ", 1),
            (__props.product.isfavo)
              ? (_openBlock(), _createElementBlock("i", _hoisted_16))
              : (_openBlock(), _createElementBlock("i", _hoisted_17))
          ])
        ]),
        _: 1
      }, 8, ["listen-variable"])
    ])
  ]))
}
}

})